import ChooseContact from "components/AddresseePicker/ChooseContact";
import LabelledDivRow from "components/LabelledDivRow";
import NumberInput from "components/NumberInput";
import OptionalTimePicker from "components/OptionalTimePicker";
import VenueModalPicker from "components/Picker/VenuePicker/VenueModalPicker";
import AgeRestrictionDropdown from "components/dropdowns/reactselect/AgeRestrictionDropdown";
import { DoorsFormState } from "shared/utils/fieldsHelper/companyFields";
import React from "react";
import { getAgeRestriction } from "utilities/enumutils";
import { parseFromTime } from "utilities/momentutils";

interface Props {
  venue: server.dto.VenueSmall
  onVenueChange: (
    venue: server.dto.VenueSmall,
    capacity: number,
    ageRestriction: server.dto.AgeRestrictions,
    doors: DoorsFormState
  ) => void
  onVenueRemoved: () => void

  contact: server.dto.ContactSmallV2
  onContactChange: (contact: server.dto.ContactSmallV2) => void

  capacity: number
  onCapacityChange: (capacity: number) => void

  ageRestriction: server.dto.AgeRestrictions
  onAgeRestrictionChange: (ageRestriction: server.dto.AgeRestrictions) => void

  doors: DoorsFormState
  onDoorsChange: (doors: DoorsFormState) => void
}

const VenuePanel = (props: Props) => {
  const onVenueSelected = async (selected: server.dto.VenueSmall) => {
    props.onContactChange(null);

    if (selected == null) {
      props.onVenueRemoved();
      return;
    }

    const venueRes = await window.CoreApi.Venue.GetVenue(selected.venueId);
    const details = venueRes.data.data.details;

    props.onVenueChange(selected,
      details.capacity,
      details.ageRestriction,
      {
        open: details.doors?.open ? parseFromTime(details.doors.open) : null,
        close: details.doors?.close ? parseFromTime(details.doors.close) : null,
      }
    );
  };

  const hasVenue = props.venue != null;

  const ageRestriction = getAgeRestriction(props.ageRestriction);

  return (<>
    <LabelledDivRow label={site.currentEnvironment.functionGroups.venue.singular}>
      <div>
        <VenueModalPicker
          canCreateNew
          afterCreate="closeSidebar"
          nonInPageEditing={{
            onChange: v => onVenueSelected(v),
            value: props.venue,
            required: false,
            validatorKey: "venue",
          }}
        />
      </div>
      {hasVenue && <div className="grow1">
        <ChooseContact
          companyId={props.venue.venueId}
          selectedContact={props.contact}
          onContactChanged={props.onContactChange}
        />
      </div>}
    </LabelledDivRow>
    {hasVenue && <>
      <LabelledDivRow label={RESX.Venue.Capacity}>
        <div className="flex gap-small">
          <div>
            <NumberInput
              maxLength={6}
              maxValue={serverReference.constants.venue.maxCapacity}
              value={props.capacity}
              canBeEmpty
              canBeNegative={false}
              decimalPoints={0}
              onChanged={v => { props.onCapacityChange(v.value); }}
              width={60}
            />
          </div>
          <div className="align-center" style={{ alignSelf: "center" }}>
            PAX
          </div>
        </div>
      </LabelledDivRow>

      <LabelledDivRow label={RESX.Venue.AgeRestrictions}>
        <AgeRestrictionDropdown
          value={ageRestriction}
          onChange={v => props.onAgeRestrictionChange(v.value)}
        />
      </LabelledDivRow>

      <LabelledDivRow label={RESX.TimetableEvent.DoorsOpen}>
        <OptionalTimePicker
          value={props.doors.open}
          onChange={(value) => props.onDoorsChange({ ...props.doors, open: value })}
        />
      </LabelledDivRow>

      <LabelledDivRow label={RESX.TimetableEvent.DoorsClose}>
        <OptionalTimePicker
          value={props.doors.close}
          onChange={(value) => props.onDoorsChange({ ...props.doors, close: value })}
        />
      </LabelledDivRow>
    </>}
  </>
  );
};

export default VenuePanel;
